<template>
  <v-card class="ma-2 pa-2">
    <div class="d-flex align-center">
      <div class="text-h6 text-capitalize mr-2">
        {{ event.component.replace(/_/g, " ") }} ({{ event.number }})
      </div>
      <v-chip
        dark
        label
        text-color="white"
        :color="getTypeColor(event.type)"
        small
        width="200px"
      >
        <v-icon left>
          mdi-label
        </v-icon>
        <div class="text-lowercase">
          {{ event.type }}
        </div>
      </v-chip>
      <v-spacer></v-spacer>
      <v-chip :color="getStatusColor(event.status)" dark>
        <div class="text-lowercase">
          {{ event.status.replace(/_/g, " ") }}
        </div>
      </v-chip>
    </div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          label="Timestamp"
          :value="event.timestamp"
          readonly
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          label="Correlation ID"
          :value="event.correlation_id"
          readonly
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-end align-center" v-if="!event.error">
        <v-btn icon @click="expandEvent(event.timestamp)"
          ><v-icon>{{
            expand === event.timestamp ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-card
        v-show="expand === event.timestamp"
        tile
        class="mx-auto yellow lighten-5 pa-2"
      >
        {{ event.order }}
      </v-card>
    </v-expand-transition>
    <div v-if="event.error">
      <v-alert color="red" type="error">
        {{ event.error }}
      </v-alert>
      <v-card tile class="mx-auto yellow lighten-5 pa-2">
        {{ event.additional_fields }}
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { pipeline } from ".";

export default {
  props: {
    event: { type: Object },
  },
  data() {
    return {
      expand: null,
    };
  },
  methods: {
    getStatusColor: (status) => pipeline.getStatusColor(status),
    getTypeColor: (status) => pipeline.getTypeColor(status),
    expandEvent(timestamp) {
      if (this.expand === timestamp) {
        this.expand = null;
      } else {
        this.expand = timestamp;
      }
    },
  },
};
</script>
